import axios from '../../common/utils/interceptor';
import { apiUrls, DEVICE_DESKTOP, MacOS } from '../../constants';
import { SessionStore } from '../../constants/sessionStore';
import { ProctoringConfig } from '../interfaces/candidateConsent';
import DeviceDetector, { DeviceDetectorResult } from 'device-detector-js';

const deviceDetector = new DeviceDetector();
export const getProctoringConfig = (): ProctoringConfig | null | undefined => {
  let projectId = null;
  const workflowSession = sessionStorage.getItem(SessionStore.workflowSession);
  if (workflowSession) {
    try {
      projectId = JSON.parse(workflowSession).projectId;
    } catch (error) {
      console.error('Fetch project ID error: ', error);
    }
  }
  if (projectId) {
    const proctoringDetails = localStorage.getItem(String(projectId));
    if (proctoringDetails) return JSON.parse(proctoringDetails);
  }
  return null;
};

export const proctoringEnabled = (): boolean => {
  const proctoringSettings = getProctoringConfig();
  if (proctoringSettings) {
    const { offFocus, copyPaste, printScreen, multiFaceDetection, periodicSnapshot } = proctoringSettings;
    return offFocus || copyPaste || printScreen || multiFaceDetection || periodicSnapshot;
  }
  return false;
};

export const storeProctoringConfig = async (): Promise<void> => {
  try {
    let projectId = null;
    const workflowSession = sessionStorage.getItem(SessionStore.workflowSession);
    if (workflowSession) {
      try {
        projectId = JSON.parse(workflowSession).projectId;
        localStorage.removeItem(String(projectId));
      } catch (error) {
        console.error('Fetch project ID error: ', error);
      }
    }
    const { data } = await axios.get(apiUrls.GET_PROCTORING_CONFIG_URL);
    if (data && projectId) {
      localStorage.setItem(String(projectId), JSON.stringify(data));
    }
  } catch (error) {
    console.error('Fetch proctoring error: ', error);
  }
};

export const showCandidateConsent = (): boolean => {
  const detectedDevice: DeviceDetectorResult = deviceDetector.parse(navigator.userAgent);
  const isProctoringEnabled = proctoringEnabled();

  if (
    isProctoringEnabled &&
    detectedDevice &&
    detectedDevice.os &&
    detectedDevice.os.name === MacOS &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 1
  ) {
    return false;
  }
  if (isProctoringEnabled && detectedDevice && detectedDevice.device && detectedDevice.device.type === DEVICE_DESKTOP) {
    return true;
  }
  return false;
};
